import { HiddenField } from "@/components/Form/Parts/index";
import PaymentIconImage from "@/components/Images/PaymentIconImage";
import { PAYMENT_METHOD_ID } from "@/lib/constants";
import formStyles from "@/styles/Form.module.scss";
import styles from "@/styles/PaymentSelect.module.scss";
import classnames from "classnames";
import { useCallback, useMemo, useState } from "react";
import { CREATE_ONLY_MODE, IGNORE_CARRIER, IGNORE_PAYPAY } from "./index";
import PaymentRadioButton from "./PaymentRadioButton";

export default function PaymentInstrumentsList({
  mode,
  paymentInstruments,
  register,
  onChange,
}) {
  if (CREATE_ONLY_MODE.includes(mode)) return null;
  if (!paymentInstruments) return null;

  const paymentRegistration = register("paymentInstrument");

  // 支払い方法ごとに分ける
  const creditCard = useMemo(() => {
    return paymentInstruments.filter(
      (v) =>
        v.payment_method_id === PAYMENT_METHOD_ID.CREDIT_CARD_3DS ||
        v.payment_method_id === PAYMENT_METHOD_ID.CREDIT_CARD_NO3DS
    );
  }, [paymentInstruments]);

  const paypay = useMemo(() => {
    return paymentInstruments.filter(
      (v) =>
        !IGNORE_PAYPAY.includes(mode) &&
        v.payment_method_id === PAYMENT_METHOD_ID.PAYPAY
    );
  }, [mode, paymentInstruments]);

  const carrier = useMemo(() => {
    return paymentInstruments.filter(
      (v) =>
        !IGNORE_CARRIER.includes(mode) &&
        [
          PAYMENT_METHOD_ID.AU,
          PAYMENT_METHOD_ID.DOCOMO,
          PAYMENT_METHOD_ID.SOFTBANK,
        ].includes(v.payment_method_id)
    );
  }, [mode, paymentInstruments]);

  const handleChange = useCallback(
    (e, methodId) => {
      paymentRegistration.onChange(e);
      onChange({
        paymentMethod: methodId,
        createPayment: false,
        showInput: false,
      });
    },
    [onChange, paymentRegistration]
  );

  const cardNumber = useCallback((v) => {
    return " ****-****-****-" + v.values.card_number;
  }, []);

  const labelClassName = useCallback((v) => {
    const cardType = v?.values?.card_type;
    return classnames(styles.radioCheck, styles.paymentMethodIcon, {
      [styles.visa]: cardType === "visa",
      [styles.jcb]: cardType === "jcb",
      [styles.master]: cardType === "mastercard",
      [styles.amex]: cardType === "amex",
      [styles.diners]: cardType === "dinersclub",
      [styles.paypay]: v.payment_method_id === PAYMENT_METHOD_ID.PAYPAY,
      [styles.docomo]: v.payment_method_id === PAYMENT_METHOD_ID.DOCOMO,
      [styles.softbank]: v.payment_method_id === PAYMENT_METHOD_ID.SOFTBANK,
      [styles.au]: v.payment_method_id == PAYMENT_METHOD_ID.AU,
    });
  }, []);

  return (
    <fieldset
      className={`${formStyles.marginOff} ${styles.paymentInstrumentsListFieldset}`}
    >
      <p className={styles.paymentInstrumentsListFieldsetTitle}>
        ご登録済みのお支払い方法を利用する
      </p>
      <div className={styles.paymentInstrumentStyle}>
        {creditCard && (
          <>
            {creditCard.map((v) => (
              <PaymentRadioButton
                key={`paymentInstrument-${v.payment_instrument_id}`}
                {...paymentRegistration}
                onChange={(e) => handleChange(e, v.payment_method_id)}
                paymentMethodId={v.payment_method_id}
                id={`paymentInstrumentId${v.payment_instrument_id}`}
                className={labelClassName(v)}
                value={v.payment_instrument_id}
              >
                <div className={styles.iconWithText}>
                  <PaymentIconImage
                    large
                    paymentMethodId={v.payment_method_id}
                    cardType={v.values.card_type}
                    className={styles.cardImage}
                  />
                  <span className={styles.paymentCreditCardText}>
                    {v.payment_method.name}
                  </span>
                  <span className={styles.paymentCreditCardText}>
                    {cardNumber(v)}
                  </span>
                </div>
              </PaymentRadioButton>
            ))}
          </>
        )}
        {paypay && (
          <>
            {paypay.map((v) => (
              <PaymentRadioButton
                key={`paymentInstrument-${v.payment_instrument_id}`}
                {...paymentRegistration}
                onChange={(e) => handleChange(e, v.payment_method_id)}
                paymentMethodId={v.payment_method_id}
                id={`paymentInstrumentId${v.payment_instrument_id}`}
                className={labelClassName(v)}
                value={v.payment_instrument_id}
              >
                <PaymentIconImage
                  large
                  paymentMethodId={v.payment_method_id}
                  cardType={v.values.card_type}
                />
              </PaymentRadioButton>
            ))}
          </>
        )}
        {carrier && (
          <div className={styles.carrierPayments}>
            {carrier.map((v) => (
              <PaymentRadioButton
                key={`paymentInstrument-${v.payment_instrument_id}`}
                {...paymentRegistration}
                onChange={(e) => handleChange(e, v.payment_method_id)}
                paymentMethodId={v.payment_method_id}
                id={`paymentInstrumentId${v.payment_instrument_id}`}
                className={labelClassName(v)}
                value={v.payment_instrument_id}
              >
                <PaymentIconImage
                  large
                  paymentMethodId={v.payment_method_id}
                  cardType={v.values.card_type}
                />
              </PaymentRadioButton>
            ))}
          </div>
        )}
      </div>
    </fieldset>
  );
}
